import React from 'react';

export default function Spinner({ label = 'Načítání…', className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-3 py-10 text-gray-600 ${className}`} role="status">
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-indigo-200 border-t-indigo-600" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
